<template>
  <BaseDialog
    :is-visible="true"
    class="cfe-confirmation-dialog full-screen"
    width="960px"
    :title="$t('mbti.cfe.confirmation.title')"
    :subtitle="$t('mbti.cfe.confirmation.subtitle')"
    @close-dialog="$emit('close-dialog', true)"
  >
    <template #footer>
      <div class="btn btn-close" @click="$emit('close-dialog', true)">
        {{ $t('mbti.cfe.confirmation.close') }}
      </div>
      <div class="btn btn-book" @click="goToBookingPage">
        {{ $t('mbti.cfe.confirmation.book') }}
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/Base/Dialog';
import { getParentSiteUrl } from '@/utils/urlHelper';
import { mapState } from 'vuex';

export default {
  components: { BaseDialog },
  computed: {
    ...mapState('userOtherSetting', ['countryId']),
  },
  methods: {
    goToBookingPage() {
      const parentSiteUrl = getParentSiteUrl(this.countryId);
      window.open(`${parentSiteUrl}/MyBizmates/student/schedule`, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.cfe-confirmation-dialog ::v-deep {
  .title {
    margin-top: 24px;
  }

  .subtitle {
    margin-top: 24px !important;
    margin-bottom: 24px;
    line-height: 18px;
  }

  .btn {
    display: flex;
    border-radius: 8px;
    width: 240px;
    max-width: 382px;
    padding: 16px 0px;
    box-sizing: border-box;
    min-height: 56px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;

    &.btn-close {
      border: 1px solid #0087d2;
      background: #ffffff;
      color: #0087d2;
      margin-right: 24px;

      @media screen and (max-width: 959px) {
        margin-right: 8px;
      }
    }

    &.btn-book {
      background: #0087d2;
      color: #ffffff;
    }
  }

  .body-scrollbar {
    @media screen and (max-width: 959px) {
      display: flex;
      align-items: center;
      justify-content: center;
      justify-items: center;
      flex-direction: column;
    }
  }
}
</style>
